import PrebookingTable from './styled';

export default PrebookingTable;
